<template>
  <span
    class="Polaris-Badge"
    :class="{
      'Polaris-Badge--toneSuccess': type === 'success',
      'Polaris-Badge--toneAttention': type === 'attention',
      'Polaris-Badge--toneInfo': type === 'info'
    }"
  >
    <span class="Polaris-Text--root Polaris-Text--bodySm">{{ title }}</span>
  </span>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Active"
    },
    type: {
      type: String,
      default: "success"
    }
  }
};
</script>

<style></style>
